import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../helpers";

const name = "dist";

// Initial state (updated with moderator post data)
// Musorka - clean it up before production
const createInitialState = () => ({
    posts: [],
    loading: false,
    test_data: null,
    generating: false,
    generated: false,
    dist_post_title: "",
    dist_post_prompt: "",
    dist_post_type: 0, // 1 for text, 0 for link
    selected_employees: [],
    jobStatus: {},
    // New moderator post state
    moderatorPosts: {}, // employeeId -> post data
    tempImages: {}, // employeeId -> uploaded images
    tempVideos: {}, // employeeId -> uploaded videos
    employeeSocialMediaMap: {},
    form: {
        title: "",
        instruction: "",
        contentType: 1, // 0 = link, 1 = text
        postLink: "",
        postText: "",
        languages: ["ru"]
    },
});

// ✅ Fixed: Directly create the thunk
const getTestData = createAsyncThunk(`${name}/test_data`, async () => {
    const data = await fetchWrapper.get(`${process.env.REACT_APP_API_URL}/dist/test`);
    return data; // Must return the payload!
});

const fetchEmployeeSocialMedia = createAsyncThunk(`${name}/fetchEmployeeSocialMedia`, async () => {
    const data = await fetchWrapper.get(`${process.env.REACT_APP_API_URL}/dist/employees-social-media`);
    return data;
});

// Extra reducers (simplified)
const createExtraReducers = (builder) => {
    builder
        .addCase(getTestData.pending, (state) => {
            state.loading = true;
        })
        .addCase(getTestData.fulfilled, (state, action) => {
            state.test_data = action.payload;
            state.loading = false;
        })
        .addCase(getTestData.rejected, (state) => {
            state.loading = false;
        });

    builder.addCase(fetchEmployeeSocialMedia.fulfilled, (state, action) => {
        // Преобразуем массив токенов в employeeId -> array of platforms
        const grouped = {};
        console.log(action.payload);
        action.payload.forEach((token) => {
            if (!grouped[token.userId]) grouped[token.userId] = [];
            grouped[token.userId].push(token.socialMediaType);
        });
        state.employeeSocialMediaMap = grouped;
    });
};

// Create the slice
const slice = createSlice({
    name,
    initialState: createInitialState(),
    reducers: {
        // Old moderator post reducers
        // Track the Redis job status
        setJobStatus(state, action) {
            const { employeeId, jobId, status, result, error } = action.payload;
            state.jobStatus[employeeId] = {
                jobId,
                status,
                result: result ? { ...result } : result, // clone to ensure reference changes
                error
            };
        },
        resetJobStatus(state) {
            state.jobStatus = {};
        },
        // Change the selected employees
        setSelectedEmployees(state, action) {
            state.selected_employees = action.payload;
        },
        // New moderator post reducers
        // Set moderator
        setModeratorPost(state, action) {
            const { employeeId, postData } = action.payload;
            state.moderatorPosts[employeeId] = {
                ...state.moderatorPosts[employeeId],
                ...postData,
            };
        },
        updateModeratorPostText(state, action) {
            const { employeeId, text } = action.payload;
            if (!state.moderatorPosts[employeeId]) {
                state.moderatorPosts[employeeId] = {};
            }
            state.moderatorPosts[employeeId].post = text;
        },
        updateModeratorPostHashtags(state, action) {
            const { employeeId, hashtags } = action.payload;
            if (!state.moderatorPosts[employeeId]) {
                state.moderatorPosts[employeeId] = {};
            }
            state.moderatorPosts[employeeId].hashtags = hashtags;
        },
        updateModeratorPostMedia(state, action) {
            const { employeeId, media } = action.payload;
            if (!state.moderatorPosts[employeeId]) {
                state.moderatorPosts[employeeId] = {};
            }
            state.moderatorPosts[employeeId].media = media;
        },
        setTempImages(state, action) {
            const { employeeId, images } = action.payload;
            state.tempImages[employeeId] = images;
        },
        addTempImage(state, action) {
            const { employeeId, image } = action.payload;
            if (!state.tempImages[employeeId]) {
                state.tempImages[employeeId] = [];
            }
            if (state.tempImages[employeeId].length < 6) {
                state.tempImages[employeeId].push(image);
            }
        },
        removeTempImage(state, action) {
            const { employeeId, index } = action.payload;
            if (state.tempImages[employeeId]) {
                state.tempImages[employeeId].splice(index, 1);
            }
        },
        clearTempImages(state, action) {
            const { employeeId } = action.payload;
            state.tempImages[employeeId] = [];
        },
        setTempVideo(state, action) {
            const { employeeId, video } = action.payload;
            state.tempVideos[employeeId] = video;
        },
        clearTempVideo(state, action) {
            const { employeeId } = action.payload;
            state.tempVideos[employeeId] = null;
        },
        clearModeratorPost(state, action) {
            const { employeeId } = action.payload;
            delete state.moderatorPosts[employeeId];
            delete state.tempImages[employeeId];
            delete state.tempVideos[employeeId];
        },
        setGenerating(state, action) {
            state.generating = action.payload;
        },
        setFormValue(state, action) {
            const { key, value } = action.payload;
            state.form[key] = value;
        },

        updateForm(state, action) {
            state.form = { ...state.form, ...action.payload };
        },
        clearJobStatus(state, action) {
            const { employeeId } = action.payload;
            if (state.jobStatus && state.jobStatus[employeeId]) {
                delete state.jobStatus[employeeId];
            }
        },

        resetForm(state) {
            state.form = {
                title: "",
                instruction: "",
                contentType: 1,
                postLink: "",
                postText: "",
                languages: ["ru"],  // default language in array
            };
        },
    },
    extraReducers: createExtraReducers,
});

// Export actions (including the thunk)
export const distActions = { ...slice.actions, getTestData, fetchEmployeeSocialMedia };
export const distReducer = slice.reducer;
